import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=adf32bf4&scoped=true"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=adf32bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf32bf4",
  null
  
)

export default component.exports